var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.783 31.4001C10.8961 31.4001 10.1437 31.0915 9.52578 30.4744C8.90866 29.8565 8.6001 29.1041 8.6001 28.2172V11.783C8.6001 10.8961 8.90866 10.1437 9.52578 9.52578C10.1437 8.90866 10.8961 8.6001 11.783 8.6001H28.2172C29.1041 8.6001 29.8565 8.90866 30.4744 9.52578C31.0915 10.1437 31.4001 10.8961 31.4001 11.783V28.2172C31.4001 29.1041 31.0915 29.8565 30.4744 30.4744C29.8565 31.0915 29.1041 31.4001 28.2172 31.4001H11.783Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.584815f150fee2739182491368764d0e.svg";
export { ForwardRef as ReactComponent };